export default class Payment {
  static async retrieve(axios, id) {
    const response = await axios.post('/graphql/', {
      query: `query couponRetrieve($id: ID!) {
        paymentRetrieve(id: $id){
          id
          shoppingCars {
            coupons {
              id
              title
              subTitle
              description
              price
              saveValue
            }
            amount
          }
          amount
          dateTime
          brand
          last4
        }
      }`,
      variables: {
        "id": id
      }
    },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.paymentRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        paymentList {
          results {
            id
            shoppingCars {
              coupons {
                id
                title
                subTitle
                description
                price
                saveValue
              }
              amount
            }
            amount
            dateTime
            brand
            last4
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.paymentList.results.reverse();
  }

  static async allOfBranchOffice(axios, branchOffice, init, last) {
    let initField = init !== '' && init !== undefined ? `, dateTime_Gte: "${init}"`: '';
    let lastField = last !== '' && last !== undefined ? `, dateTime_Lte: "${last}"`: '';
    const response = await axios.post(
      '/graphql/',
      `query {
        paymentBranchOffice(branchOfficeId: ${branchOffice} ${initField} ${lastField}) {
          id
          shoppingCars {
            coupons {
              id
              title
              subTitle
              description
              price
              saveValue
            }
            amount
          }
          amount
          dateTime
          brand
          last4
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.paymentBranchOffice;
  }

  static async allOfCompany(axios, company, init, last) {
    let initField = init !== '' && init !== undefined ? `, dateTime_Gte: "${init}"`: '';
    let lastField = last !== '' && last !== undefined ? `, dateTime_Lte: "${last}"`: '';
    const response = await axios.post(
      '/graphql/',
      `query {
        paymentCompany(companyId: ${company} ${initField} ${lastField}) {
          id
          shoppingCars {
            coupons {
              id
              title
              subTitle
              description
              price
              saveValue
            }
            amount
          }
          amount
          dateTime
          brand
          last4
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.paymentCompany;
  }

  static async filter(axios, init, last) {
    const response = await axios.post(
      '/graphql/',
      `query{
        paymentList (dateTime_Gte: "${init}", dateTime_Lte: "${last}") {
          results {
            id
            shoppingCars {
              coupons {
                id
                title
                subTitle
                description
                price
                saveValue
              }
              amount
            }
            amount
            dateTime
            brand
            last4
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.paymentList.results.reverse();
  }
}